import { Component } from '@angular/core';
import { TranslateService } from 'ng2-translate';


@Component({
  selector: 'app-proceso',
  templateUrl: './proceso.component.html'
})
export class ProcesoComponent {
  constructor( private translate:TranslateService  ){

  }

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/components/proceso/proceso.component.ts